__turbopack_context__.v({
  "classInfo": "QNmoQW_classInfo",
  "classInfoClassNum": "QNmoQW_classInfoClassNum",
  "classInfoClassType": "QNmoQW_classInfoClassType",
  "classInfoContent": "QNmoQW_classInfoContent",
  "classInfoDefaultText": "QNmoQW_classInfoDefaultText",
  "classInfoInfoText": "QNmoQW_classInfoInfoText",
  "classInfoTop": "QNmoQW_classInfoTop",
  "container": "QNmoQW_container",
  "empty": "QNmoQW_empty",
  "groupList": "QNmoQW_groupList",
  "noMarginTop": "QNmoQW_noMarginTop",
  "selectActiveClass": "QNmoQW_selectActiveClass",
  "selectActiveClassTitle": "QNmoQW_selectActiveClassTitle",
  "selectClassesBlock": "QNmoQW_selectClassesBlock",
  "selectMktuBlockTitle": "QNmoQW_selectMktuBlockTitle",
  "visible": "QNmoQW_visible",
});
